import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App'
import './assets/styles/index.css'

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(
    <Router>
      <App />
    </Router>
  )
} else {
  console.error('Root container not found')
}
